<!-- View Training Details -->

<!-- Session View -->

<h3>{{data?.title}}</h3>
<h6>{{data?.type.type.arabic}}</h6>
<p-divider align="left">
    <div class="inline-flex align-items-center">
        <i class="pi pi-map-marker ml-2 mr-2"></i>
        <b> {{"Address" | translator}} </b>
    </div>
</p-divider>

<span [innerHTML]="data.description"></span>
<p>{{"start date" | translator}} : {{data?.start_date | date}}</p>
<p>{{"end date"  | translator}} : {{data?.end_date | date}}</p>
<p-accordion [multiple]="true" [activeIndex]="[0]">
    <p-accordionTab *ngFor="let session of data.session">
        <ng-template class="d-flex justify-content-between" pTemplate="header">
            <div class="d-flex justify-content-between">
                <div class="flex align-items-center mx-1">
                    <i class="pi pi-bookmark-fill mx-1"></i>
                    <span class="vertical-align-middle">{{session.title}}</span>
                </div>
                <div class="mx-1">
                    <span class="vertical-align-middle">({{session.type}})</span>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="content">
            <p-divider align="left">
                <div class="inline-flex align-items-center">
                    <i class="pi pi-bookmark-fill ml-2 mr-2"></i>
                    <b> {{"Session Details"  | translator}} </b>
                </div>
            </p-divider>

            <p class="m-0"><span class="font-bold">{{"session Date" | translator}} :</span> {{session.date | date}}</p>
            <p [hidden]="!session.start_time" class="m-0"><span class="font-bold">{{"Start time"  | translator}} :</span>
                {{session.start_time}}</p>
            <p [hidden]="!session.end_time" class="m-0"><span class="font-bold">{{"End time"  | translator}} :</span> {{session.end_time }}
            </p>

            <!-- for course -->
            <section *ngIf="session.type == 'COURSE'">
                <app-view-course-details [data]="session.typeId"></app-view-course-details>
            </section>
            <!-- End for course -->

            <!-- for Assessment -->
            <section *ngIf="session.type == 'ASSESSMENT'">
                <p-divider align="left">
                    <div class="inline-flex align-items-center">
                        <i class="pi pi-book ml-2 mr-2"></i>
                        <b> {{"Assessment Details"  | translator}} </b>
                    </div>
                </p-divider>
                <h3> {{session.typeId.assessmentTitle}}</h3>
                <h5><span class="font-bold">{{"Assessment type" | translator}} :</span> {{session.typeId.assessmentType }}</h5>
                <p><span class="font-bold">{{"Description"  | translator}} :</span> {{session.typeId.description }}</p>
            </section>
            <!-- End for course -->

            <!-- for course -->
            <section *ngIf="session.type == 'SURVEY'">
                <p-divider align="left">
                    <div class="inline-flex align-items-center">
                        <i class="pi pi-chart-line ml-2 mr-2"></i>
                        <b> {{"Survey Details"  | translator}} </b>
                    </div>
                </p-divider>
                <h3> {{session.typeId.surveyTitle}}</h3>
                <h5><span class="font-bold">{{"Survey type"  | translator}} :</span>{{session.typeId.surveyType }}</h5>
                <p><span class="font-bold">{{"Description"  | translator}} :</span> {{session.typeId.description }}</p>
            </section>
            <!-- End for course -->

            <!-- for Program -->
            <section *ngIf="session.type == 'PROGRAM'">
                <h4>{{"Trainer"  | translator}} : {{session.typeId.trainer.name}}</h4>
                <div *ngIf="session.typeId.is_online; else elseBlock">
                    <p>{{"Course will be conducted Online"  | translator}}</p>
                </div>
                <ng-template #elseBlock>
                    <p-divider align="left">
                        <div class="inline-flex align-items-center">
                            <i class="pi pi-map-marker ml-2 mr-2"></i>
                            <b> {{"Address"  | translator}} </b>
                        </div>
                    </p-divider>
                    <p><span class="font-bold">{{"Number"  | translator}} :</span> {{session.typeId.houseNumber}}</p>
                    <p><span class="font-bold">{{"Street"  | translator}} :</span> {{session.typeId.street}}</p>
                    <p><span class="font-bold">{{"City"  | translator}} :</span> {{session.typeId.city}}</p>
                </ng-template>
            </section>
            <!-- End for course -->

        </ng-template>

    </p-accordionTab>
</p-accordion>
<!-- End Session View -->